export const getURLWithoutParams = () => {
    return window.location.origin + window.location.pathname;
};

export const getParam = (param: string): string | null => {
    const params = new URLSearchParams(window.location.href);
    return params.get(param);
};
